import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { HttpErrorService } from '../services/http-error.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({ providedIn: 'root' })
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private httpErrorService: HttpErrorService,
    private spinner: NgxSpinnerService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          this.spinner.hide();
          this.authService.logout();
        }
        const detail = err.error && err.error.detail;
        // Errores estructurados del backend (p.ej. columnas faltantes o validaciones):
        // se propaga el HttpErrorResponse original para que el componente pueda leer
        // error.error.detail y construir un mensaje claro para el usuario.
        const hasStructuredDetail =
          (Array.isArray(detail) && detail.some((d) => d && typeof d === 'object')) ||
          (detail !== null && typeof detail === 'object');
        if (hasStructuredDetail) {
          return throwError(err);
        }
        let errors = [];
        if (err.error) {
          if (err.status === 0) {
            errors = [
              'No tiene acceso al servidor, por favor verifique su conexión',
            ];
          } else if (err.error instanceof Array) {
            errors = err.error.map((e) =>
              e.error ? e.error : 'Ocurrió un error'
            );
          } else if (err.status === 404) {
            errors = ['Error 404: No existe el recurso en el servidor'];
          }  else if (err.status === 401) {
            errors = ['Su sesión a expirado, por favor vuelva a ingresar'];
          } else if (Array.isArray(detail)) {
            errors = detail.map((d) =>
              typeof d === 'string' ? d : (d && (d.message || d.msg)) || 'Ocurrió un error'
            );
          } else {
            errors = [
              detail || err.error.error || err.error.message || err.statusText || err.error.toString(),
            ];
          }
        } else {
          errors = [err.message || err.statusText || err.toString()];
        }
        this.httpErrorService.setErrorList(errors);
        return throwError(errors);
      })
    );
  }
}
